import styled from "styled-components";
import colors from "../../constants/colors";

export const SelectWrapper = styled("div")({
  position: "relative",
  width: "100%",
});

export const SelectElement = styled("select")<{ disabled?: boolean }>({
  padding: "0.625rem 0.625rem 0.625rem 2rem",
  border: `1.5px solid ${colors.GREY_3}`,
  borderRadius: "8px",
  fontSize: "0.875rem",
  textAlign: "right",
  width: "100%",
  boxSizing: "border-box",
  appearance: "none",
  backgroundColor: colors.WHITE,
  backgroundImage:
    'url(\'data:image/svg+xml;utf8,<svg fill="%23333" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>\')',
  backgroundRepeat: "no-repeat",
  backgroundPosition: "left 6px center",
  backgroundSize: "20px",
  cursor: "pointer",
  minHeight: "44px",
  "&:disabled": {
    backgroundColor: colors.GREY_2,
    cursor: "not-allowed",
    "&::placeholder": {
      textDecoration: "line-through",
    },
  },
  "&:focus": {
    outline: `none`,
    borderColor: colors.PURPLE,
    boxShadow: `0px 0px 0px 3px ${colors.PURPLE_LIGHTER}`,
  },
});

export const ErrorText = styled("div")({
  fontSize: "0.75rem",
  color: colors.ORANGE,
  marginTop: "0.25rem",
  textAlign: "right",
});
